import { createFileRoute } from "@tanstack/react-router";
import { TipoPermissao } from "features/usuario/types/ApiUsuarioTipoPermissao";
import { validateRoute } from "router/util";

export const Route = createFileRoute("/a/configuracao/empresa")({
	beforeLoad: () =>
		validateRoute({
			permissao: "upp_configuracao_configuracao",
			nivel: TipoPermissao.Completo,
		}),
});
